import { money } from "../api";

const FLAGS = { TRY: "₺", USD: "$", EUR: "€" };
const ROWS = [["portfolio_value", "Portföy"], ["total_paid", "Tahsil edilen"], ["pending_payments", "Bekleyen ödeme"], ["net_cashflow", "Net nakit"]];

export default function CurrencyBreakdown({ breakdown, latestRate }) {
  return (
    <section className="panel" data-testid="currency-breakdown">
      <div className="panel-head">
        <div><span className="eyebrow">ÇOKLU PARA BİRİMİ</span><h2>TL / USD / EUR kırılımı</h2></div>
        <small className="rate-note" data-testid="latest-rate-note">
          {latestRate ? `Kur (${latestRate.date}): 1 USD = ${latestRate.usd_try} ₺ · 1 EUR = ${latestRate.eur_try} ₺` : "Kur tanımlı değil — Finans › Kur Yönetimi"}
        </small>
      </div>
      <div className="ccy-grid">
        {Object.entries(breakdown || {}).map(([c, v]) => (
          <div className={`ccy-card ccy-${c.toLowerCase()}`} key={c} data-testid={`breakdown-${c}`}>
            <div className="ccy-head"><span className="ccy-sym">{FLAGS[c]}</span><b>{c}</b><small>{v.projects} proje</small></div>
            {ROWS.map(([k, l]) => (
              <div className="ccy-row" key={k}><span>{l}</span><b className={k === "net_cashflow" ? (v[k] >= 0 ? "margin" : "loss") : "mono-small"}>{money(v[k], c)}</b></div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
